import axios from "axios";


let domain = "https://ohmapi.austere.biz/";


const instance = axios.create({
  baseURL: domain + "hostel/api",
});

const baseUrl = () => {
  return domain;
}

export default instance;
export {
  baseUrl
}